document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.Accordions__single');

  accordions.forEach(accordion => {
      const heading = accordion.querySelector('.heading');
      const content = accordion.querySelector('.content');

      content.style.transition = "max-height 0.3s ease-out";
      content.style.overflow = "hidden";
      content.style.maxHeight = "0";

      heading.addEventListener('click', function() {
          const isActive = accordion.classList.contains('active');

          if (isActive) {
              accordion.classList.remove('active');
              content.style.maxHeight = "0";
          } else {
              accordion.classList.add('active');
              content.style.maxHeight = content.scrollHeight + "px";
          }
      });
  });
});
